import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axiosInstance from '../lib/axios';
import { Loader2, ArrowLeft } from 'lucide-react';

/**
 * Public legal document viewer. Reads /api/legal/:slug (no auth) and renders the
 * current text (admin override or draft). Used for /legal/terms and /legal/privacy.
 */
const LegalPage = () => {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setDoc(null);
    setError('');
    axiosInstance
      .get(`/legal/${slug}`)
      .then((r) => { if (!cancelled) setDoc(r.data); })
      .catch(() => { if (!cancelled) setError('No se encontró el documento.'); });
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Link to="/auth" className="inline-flex items-center gap-1 text-sm text-sky-600 dark:text-sky-400 hover:underline mb-6">
          <ArrowLeft className="w-4 h-4" /> Volver
        </Link>

        {error ? (
          <p className="text-slate-500">{error}</p>
        ) : !doc ? (
          <div className="flex items-center gap-2 text-slate-500">
            <Loader2 className="w-5 h-5 animate-spin" /> Cargando…
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {doc.title}
            </h1>
            <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed">
              {doc.text}
            </pre>
          </>
        )}
      </div>
    </div>
  );
};

export default LegalPage;
